export const environment = {
  server: 'https://booking-blank.dev.phoenixreisen.com',
  // server: 'http://localhost:3400',
  client: 'phoenix',
  production: false,
};
